import controller from './tree-view-controller';

const TreeViewComponent: angular.IComponentOptions = {
  controller,
  controllerAs: 'ctrl',
  bindings: {
    nodes: '<',
    useUpdatedIcon: '<',
    initialSelection: '@?',
    onSelect: '&?',
  },
  template: `
    <div class="tree-view">
      <tree-view-item
        is-divider="node === null"
        expanded="false"
        key="{{node.key}}"
        name="{{node.name}}"
        icon="node.icon"
        selected = "node.selected"
        props="node.props"
        nodes="node.nodes"
        use-updated-icon="ctrl.useUpdatedIcon"
        on-select="ctrl.handleSelection($key)"
        ng-disabled="node.disabled"
        ng-repeat="node in ctrl.nodes" />
    </div>
  `,
};

export { TreeViewComponent };
